import { reactMount } from '@/lib/reactMount'
import { useRef } from 'react'

export const rteBlock = ({ dataset, umbraco, version = 'default' }) => {
  const umbracoRef = useRef(umbraco || JSON.parse(dataset.umbraco))
  umbraco ||= umbracoRef.current
  const theme = umbraco.Theme || 'light'
  const backgroundColor = umbraco.BlockBackground ? `#${umbraco.BlockBackground}` : '#ffffff'

  if (!umbraco.Summary) {
    return null
  }

  return (
    <div
      id={umbraco.AnchorTarget || undefined}
      data-theme={theme}
      className={`_block-section _RTEBlock-section ${version === 'hero-carousel' ? '!bg-transparent py-5 first:-mt-[56px] xl:first:-mt-[146px] z-20 relative mb-8 last:mb-0 last:pb-8' : 'py-12'}`}
      style={{ backgroundColor }}
    >
      <div className='mx-auto max-w-7xl px-4 sm:px-6 lg:px-8'>
        <div
          className={`_rte ${version === 'hero-carousel' ? 'text-default-50' : ''}`}
          dangerouslySetInnerHTML={{ __html: umbraco.Summary }}
        />
      </div>
    </div>
  )
}

reactMount('rteBlock', rteBlock)
